import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueRequiredFilter',
  pure: false
})
export class ValueRequiredFilterPipe implements PipeTransform {

  transform(items: any[], fields: string[]): any {
    if (!items) { return []; }
    if (!fields) { return items; }
    return items.filter(it => {
      let result = true;
      fields.forEach((value, index, array) => {
        result = result && it[fields[index]];
      });
      return result;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/value-required-filter.pipe.ts